export const upsellEn = {
  'cancel-any-time': 'Cancel any time',
  description:
    'One plan with every tool your restaurant needs to grow and keep guests coming back.',
  'feature-cards': {
    app: {
      body: 'The average restaurant sees 2x more reorders from app users.',
      title: 'Branded mobile app',
    },
    reviews: {
      body: 'Owner automatically asks happy guests to leave reviews averaging 4.92 stars.',
      title: 'Automated Google review engine',
    },
    upscaling: {
      body: 'Make all your menu photos magazine worthy with AI photo upscaling.',
      title: 'AI photo upscaling',
    },
  },
  'plan-boost': 'Boost',
  'plan-pro': 'Pro',
  price: '$199',
  'price-cadence': '/mo',
  'sheet-description':
    'Upgrade to Pro and get the complete system. A branded mobile app, automatic rewards, and more ways to keep guests ordering directly from you.',
  'table-caption': 'All the features included with PRO',
  'table-rows': {
    'ai-cro': 'AI-driven conversion rate optimization',
    'auto-email': 'Automated email marketing',
    'auto-gbp': 'Auto Google Business profile posts',
    'auto-sms': 'Automated SMS marketing',
    'branded-app': 'Custom-branded mobile app',
    'branded-email': 'Branded restaurant email',
    'branded-gift-cards': 'Branded gift cards',
    'catering-forms': 'Catering and events forms',
    'custom-email': 'Customizable email marketing',
    'custom-website': 'Custom branded website',
    'delivery-support': 'Customer support for deliveries',
    'job-board': 'Website job board',
    listings: 'Online listings management on 77+ sites',
    'live-tracking': 'Live order tracking',
    'loyalty-integrations': 'Loyalty & gift card integrations',
    'online-ordering': 'Online ordering',
    'order-with-google': 'Order with Google integration',
    promotions: 'Easy-to-use promotion tools',
    'push-marketing': 'Push notification marketing',
    reputation: 'Reputation management',
    reservations: 'Reservations embed support',
    'review-engine': 'Automated Google review engine',
    'review-replies': 'Online review replies',
    seo: 'Search Engine Optimization (SEO)',
    'unified-inbox': 'Unified inbox for customer comms',
    upscaling: 'Photo upscaling & improvements',
    'website-improver': 'Website improver',
  },
  'table-sections': {
    ai: 'AI features',
    brand: 'Brand customization',
    marketing: 'Marketing',
    ordering: 'Ordering & delivery',
    website: 'Website',
  },
  title: 'Unlock your complete growth system',
  'upgrade-cta': 'Upgrade to Pro',
}
